import React, { Component } from 'react';
import {
	Cotainer,
	MainSection
} from '../../components/AppWrapper';
import ContactUs from '../../components/ContactUs';
import HelpList from './helplist.json';
import { ICON_CONTACTUS } from '../../config/media';
import Wrapper from './style';

export default class HelpPage extends Component {
	state = {
		isOpen: false
	};

	openModal = () => {
		this.setState({ isOpen: true });
	};

	closeModal = () => {
		this.setState({ isOpen: false });
	};

	renderSubLinks = (title) => {
		switch (title) {
			case 'HollaEx Docs and GitHub':
				return (
					<div className="sub-link">
						<p>
							Docs:
				  <a href="https://docs.hollaex.com" target="_blank" rel="noopener noreferrer" title="site">
								https://docs.hollaex.com
				  </a>
						</p>
						<p>
							GitHub:
				  <a href="https://github.com/hollaex/hollaex-kit" target="_blank" rel="noopener noreferrer" title="site">
								https://github.com/hollaex/hollaex-kit
				  </a>
						</p>
					</div>
				);
			case 'Developers':
				return (
					<div className="sub-link">
						<p>
							HollaEx API Docs:
				  <a href="https://apidocs.hollaex.com" target="_blank" rel="noopener noreferrer" title="site">
								https://apidocs.hollaex.com
				  </a>
						</p>
						<p>
							Developer Tools:
				  <a href="https://www.npmjs.com/package/hollaex-node-lib" target="_blank" rel="noopener noreferrer" title="site">
								https://www.npmjs.com/package/hollaex-node-lib
				  </a>
						</p>
					</div>
				);
			case 'HollaEx Articles and Media':
				return (
					<div className="sub-link">
						<p>
							HollaEx Articles:
				  <a href="https://hollaex.webflow.io/blog" target="_blank" rel="noopener noreferrer" title="site">
								https://hollaex.webflow.io/blog
				  </a>
						</p>
						<p>
							HollaEx in the Media:
				  <a href="https://www.hollaex.com/media" target="_blank" rel="noopener noreferrer" title="site">
								https://www.hollaex.com/media
				  </a>
						</p>
					</div>
				);
			default:
				return null;
		}
	};

	renderList = () => {
		return HelpList.data.map((item) => (
			<React.Fragment>
				{item.title === 'Videos Guides' ? <>
					<div className='help-header'>Help and Resources</div>
					<div className='header-contents-container'>
						<img className='contact-icon' src={ICON_CONTACTUS} alt="icon" />
						<div>
							<p className='header-title'>Learn more about HollaEx</p>
							<p style={{ margin: '0px' }}>Find guides, docs, videos and other useful resources below. To get help with your Basic on-premise exchange please post a question directly on the public</p>
							<div className='header-links-container'>
								<a href='https://forum.hollaex.com/' target="_blank" rel="noopener noreferrer">HollaEx forums.</a>
								<p style={{ marginLeft: '5px', marginBottom: '0px' }}>For cloud or paid on-premise exchanges please contact</p>
								<p className='holla-support-label' onClick={this.openModal} >HollaEx support</p>
							</div>
						</div>
					</div></> : null}
				<div className="help-card">
					<div
						className="img-box"
						style={{ backgroundImage: `url(${item.img})` }}
					></div>
					<div className='help-card-container'>
						<h3>{item.title}</h3>
						<div className="card-sub-title">{item.subtitle}</div>
						<div className="card-description">{item.description}</div>
						<div className="card-link" style={{ fontSize: '16px' }}>
							<a
								href={item.link}
								target={item.title === "Exchange App Store" ? "_self" : "_blank"}
								rel={(item.title !== "Exchange App Store") && "noopener noreferrer"}
								title={item.link}
							>
								{item.link}
							</a>
						</div>
						{this.renderSubLinks(item.title)}
					</div>
				</div>
			</React.Fragment>
		));
	};

	render() {
		const { isOpen } = this.state;
		return (
			<Cotainer>
				{/* <InfoSection>
					<div>
						<img src={HELP_IMAGE} alt="help" className="info-logo" />
						<h3>Get Help. Learn more about HollaEx and Vault.</h3>
						<p>
							You can use find guides of how to use HollaEx on this page.
							The quickest way to get answers ASAP is to sue the{' '}
							<a
								href="https://forum.hollaex.com"
								title="hollaex"
								target="_blank"
								rel="noopener noreferrer"
							>
								HollaEx forums
							</a>
						</p>
						<Button
							block
							type="primary"
							onClick={() => {
								this.props.history.push('/plugin');
							}}
						>
							<img src={ICON_ALL_PLUGIN} alt="icon" />
							Plugins
						</Button>
						<Button block type="primary">
							<a
								href="https://docs.hollaex.com/"
								title="hollaex"
								target="_blank"
								rel="noopener noreferrer"
							>
								<img src={ICON_LIST} alt="icon" />
								Docs
							</a>
						</Button>
						<Button block type="primary">
							<a
								href="https://forum.hollaex.com/faq"
								title="hollaex"
								target="_blank"
								rel="noopener noreferrer"
							>
								<img src={ICON_QUESTION} alt="icon" />
								FAQ
							</a>
						</Button>
						<Button block type="primary" onClick={this.openModal}>
							<img src={ICON_CONTACTUS} alt="icon" />
							Contact Us
						</Button>
					</div>
				</InfoSection> */}
				<MainSection>
					<Wrapper>{this.renderList()}</Wrapper>
					{isOpen ? (
						<ContactUs
							visible={isOpen}
							defaultType="Other"
							handleOk={this.closeModal}
							handleError={this.closeModal}
							handleCancel={this.closeModal}
						/>
					) : null}
				</MainSection>
			</Cotainer>
		);
	}
}
